export default "__VITE_ASSET__e7XXCrpW__"